var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ListViewsDrawer',{attrs:{"views":_vm.views}}),_c('SaveViewDrawer',{attrs:{"views":_vm.views,"disabled":!_vm.user.isAuth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }